/**
 * Formatting utilities for numbers
 */

/**
 * Format number with K/M/B suffixes, one decimal place, trim trailing .0
 * @param n - Number to format
 * @returns Formatted string (e.g., "1.2K", "5M", "10B")
 */
export const short = (n: number): string => {
  if (n < 1000) return n.toString();

  const units = [
    { value: 1e9, suffix: 'B' },
    { value: 1e6, suffix: 'M' },
    { value: 1e3, suffix: 'K' },
  ];

  for (const unit of units) {
    if (n >= unit.value) {
      const formatted = (n / unit.value).toFixed(1);
      // Remove trailing .0
      return formatted.endsWith('.0')
        ? formatted.slice(0, -2) + unit.suffix
        : formatted + unit.suffix;
    }
  }

  return n.toString();
};

/**
 * Format number with comma separators for tooltips
 * @param n - Number to format
 * @returns Comma-formatted string (e.g., "1,234,567")
 */
export const full = (n: number): string => {
  return n.toLocaleString();
};
